"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayTimeoutError = exports.BadGatewayError = exports.InternalServerError = exports.NotFoundError = exports.TransferIsInQueueError = exports.TransferIsDirtyError = exports.TransferAlreadyLockedError = exports.UnauthorizedError = exports.InvalidParameterError = exports.GenericError = void 0;
const core_1 = require("@smash-sdk/core");
class GenericError extends core_1.SDKError {
}
exports.GenericError = GenericError;
class InvalidParameterError extends GenericError {
}
exports.InvalidParameterError = InvalidParameterError;
class UnauthorizedError extends GenericError {
}
exports.UnauthorizedError = UnauthorizedError;
class TransferAlreadyLockedError extends GenericError {
}
exports.TransferAlreadyLockedError = TransferAlreadyLockedError;
class TransferIsDirtyError extends GenericError {
}
exports.TransferIsDirtyError = TransferIsDirtyError;
class TransferIsInQueueError extends GenericError {
}
exports.TransferIsInQueueError = TransferIsInQueueError;
class NotFoundError extends GenericError {
}
exports.NotFoundError = NotFoundError;
class InternalServerError extends GenericError {
}
exports.InternalServerError = InternalServerError;
class BadGatewayError extends GenericError {
}
exports.BadGatewayError = BadGatewayError;
class GatewayTimeoutError extends GenericError {
}
exports.GatewayTimeoutError = GatewayTimeoutError;
exports.default = {
    GenericError,
    InvalidParameterError,
    UnauthorizedError,
    TransferAlreadyLockedError,
    TransferIsDirtyError,
    TransferIsInQueueError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
